import { render, staticRenderFns } from "./LandingNLPWidget.vue?vue&type=template&id=175157bb&"
import script from "./LandingNLPWidget.vue?vue&type=script&lang=js&"
export * from "./LandingNLPWidget.vue?vue&type=script&lang=js&"
import style0 from "./LandingNLPWidget.vue?vue&type=style&index=0&id=175157bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports